import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    '&:last-child': {
      paddingBottom: theme.spacing(3),
    },
  },
  tableContainer: {
    maxHeight: 360,
    overflow: 'auto',
  },
  rank: {
    fontWeight: 700,
    color: theme.palette.text.secondary,
  },
}));

interface TopProject {
  projectId: number;
  projectName: string;
  count: number;
}

interface TopProjectsCardProps {
  topProjects: TopProject[];
}

export const TopProjectsCard = ({ topProjects }: TopProjectsCardProps) => {
  const classes = useStyles();

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.content}>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Projetos Mais Deployados
        </Typography>
        {topProjects.length === 0 ? (
          <Typography color="textSecondary" variant="body2">
            Nenhum dado disponível
          </Typography>
        ) : (
          <TableContainer className={classes.tableContainer}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Projeto</TableCell>
                  <TableCell align="right">Deploys</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {topProjects.map((project, index) => (
                  <TableRow key={project.projectId}>
                    <TableCell className={classes.rank}>
                      {index + 1}
                    </TableCell>
                    <TableCell>{project.projectName}</TableCell>
                    <TableCell align="right">{project.count}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
};
